import "@shared/ui.primitives/style.css";
import "@shared/ui.components/style.css";
import { mainContentContainer, pageContainer } from "./style.css";

type PageProps = {
  children: React.ReactNode;
};

export const PearlPage: React.FC<PageProps> = ({ children }) => {
  return (
    <>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      {/* ! NEED TO ADD BACK THE SEO COMPONENT */}
      <div className={pageContainer}>
        <div className={mainContentContainer}>{children}</div>
      </div>
    </>
  );
};
